/**
 * AppStore Admin Routes Configuration
 */

import React, { lazy } from 'react';
import type { RouteObject } from 'react-router-dom';

// Lazy load dashboards and pages
const AdminDashboard = lazy(() => import('../dashboards/AdminDashboard'));
const CreateApp = lazy(() => import('../pages/CreateApp'));

/**
 * AppStore Admin child routes (for use within app-designer)
 */
export const appstoreAdminChildRoutes: RouteObject[] = [
  {
    index: true,
    element: <AdminDashboard />
  },
  {
    path: 'create-app',
    element: <CreateApp />
  }
];

export default appstoreAdminChildRoutes;
